import { routes } from "@/routing/routes";
import type { Router } from "vue-router";
import whiteLabelConfigQuery from "@/apps/whiteLabelWebsite/whiteLabel/core/application/bridge/query/configQuery";
import { insertAxeptioScript } from "@/apps/whiteLabelWebsite/whiteLabel/core/infrastructure/service/axeptioService";
import { insertGoogleScripts } from "@/apps/whiteLabelWebsite/whiteLabel/core/infrastructure/service/gtmService";
import { pushPageViewCommand } from "@/apps/whiteLabelWebsite/whiteLabel/core/application/bridge/command/pushPageViewCommand";

const NOT_AVAILABLE_PAGE_PATH = routes.notAvailable.path;

export default async (router: Router): Promise<void> => {
  const isConfigSuccessfullyLoaded = await whiteLabelConfigQuery.isConfigSuccessfullyLoaded();

  if (!isConfigSuccessfullyLoaded) {
    const currentPath = window.location.pathname;
    if (currentPath !== NOT_AVAILABLE_PAGE_PATH) {
      window.location.href = NOT_AVAILABLE_PAGE_PATH;
    }
    return;
  }

  const axeptioId = whiteLabelConfigQuery.getConfig().axeptioId;
  if (axeptioId) {
    insertAxeptioScript(axeptioId);
  }

  const gtmId = whiteLabelConfigQuery.getConfig().tagManagerId;
  if (gtmId) {
    insertGoogleScripts(gtmId);
    router.afterEach((to) => {
      if (to.meta?.disableTMSPageViewEvent === true || to.redirectedFrom?.meta?.disableTMSPageViewEvent === true) {
        return;
      }
      pushPageViewCommand({ page_path: to.fullPath });
    });
  }
};
